import Pro1 from "../../Img/q.jpg";
import Pro2 from "../../Img/w.jpg";
import Pro3 from "../../Img/e.jpg";
import Pro4 from "../../Img/r.jpg";
import Pro5 from "../../Img/t.jpg";
import Pro6 from "../../Img/y.jpg";
import Pro7 from "../../Img/u.jpg";
import Pro8 from "../../Img/i.jpg";
import Pro9 from "../../Img/o.jpg";
import Pro0 from "../../Img/p.jpg";

export const Project = [
  {
    id: 1,
    projectName: "Electro-clone",
    stack: "React/Redux",
    link: "https://electro-com.netlify.app",
    Image: Pro1,
    type: 2,
  },
  {
    id: 2,
    projectName: "Birth-day",
    stack: "html/css/js",
    link: "https://bornday.netlify.app",
    Image: Pro2,
    type: 1,
  },
  {
    id: 3,
    projectName: "cv-resume",
    stack: "Html/css/js",
    link: "https://shafiq-cv.netlify.app",
    Image: Pro3,
    type: 3,
  },
  {
    id: 4,
    projectName: "kmaupdates",
    stack: "Wordpress",
    link: "https://kmaupdates.com",
    Image: Pro4,
    type: 2,
  },
  {
    id: 5,
    projectName: "bkca",
    stack: "WordPress",
    link: "https://bkca.co.ug",
    Image: Pro5,
    type: 2,
  },
  {
    id: 6,
    projectName: "Js Practice",
    stack: "html/css/js",
    link: "https://projects4shafiq.netlify.app",
    Image: Pro6,
    type: 1,
  },
  {
    id: 7,
    projectName: "M&A summit",
    stack: "Wordpress",
    link: "https://mergersafrica.com",
    Image: Pro7,
    type: 3,
  },
  {
    id: 8,
    projectName: "Electro-clone",
    stack: "html/css",
    link: "https://codeimpactproject1.netlify.app/",
    Image: Pro8,
    type: 2,
  },
  {
    id: 9,
    projectName: "Electro-clone",
    stack: "wordpress",
    link: "https://fufa.co.ug",
    Image: Pro9,
    type: 1,
  },
  {
    id: 0,
    projectName: "Electro-clone",
    stack: "React/Redux",
    link: "https://shafiq-folio.netlify.app",
    Image: Pro0,
    type: 3,
  },
];
